import { api } from '@cwd/lib/main';

export interface Administrator {
    UserId: string;
    Email: string;
}

export async function getAdministrators(): Promise<Administrator[]> {
    return api.get('/Roles/AllUsersInRole/BackOfficeAdministrator');
}

export async function addAdministrator(email: string): Promise<Administrator> {
    return api.post(`/Roles/AddUserRole/BackOfficeAdministrator?email=${encodeURIComponent(email)}`, null);
}

export async function removeAdministrator(userId: string): Promise<void> {
    return api.post(`/Roles/RemoveUserRole/BackOfficeAdministrator?userId=${userId}`, null);
}
